export default "__VITE_ASSET__87c832c1__"